import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import GenericModal from '~/components/GenericModal';
import UserPreferencesForm from '../forms/UserPreferencesForm';
import { userPreferencesModalOpenAtom } from '~/atoms/userPreferences';
import { isProfileCompleteAtom } from '~/atoms/userPreferences';
export default function UserPreferencesModal() {
    const [open, setOpen] = useAtom(userPreferencesModalOpenAtom);
    const profileLoadable = useAtomValue(useMemo(() => loadable(isProfileCompleteAtom), []));
    // Close only when isProfileCompleteAtom is true. API check is informational only.
    const isComplete = profileLoadable.state === 'hasData' && profileLoadable.data === true;
    return (_jsx(GenericModal, { open: open, onOpenChange: setOpen, title: "User Preferences", subtitle: "Set your default Brand, Division and Field of Play", hideClose: !isComplete, allowOutsideInteraction: isComplete, testId: "user-preferences-modal", children: _jsx(UserPreferencesForm, { onSaved: () => setOpen(false) }) }));
}
